<script setup lang="ts">
import type { TCarouselProps } from '../model/common';
import { ProductCard } from '~/features/product-card';
import CarouselSlides from './CarouselSlides.vue';

import { getSimilarProducts } from '../business/getSimilarProducts';
import { useFavorites } from '~/features/store/favorite';

const props = defineProps<TCarouselProps & { productsIds?: string[] }>();

const products = ref([]);

const { handleFavoriteToggleCurried } = useFavorites();
const { buildAnalyticsParams } = await import('@/features/store/favorite/business/analyticsParams');
const handleFavoriteToggle = handleFavoriteToggleCurried('productCarousel');

const handleFavoriteToggleWithParams = async (product: any, index: number) => {
  const extraParams = await buildAnalyticsParams('сarousel', product, {
    index,
    moduleName: 'Похожие товары',
    moduleId: 'similar-slider',
    carouselPosition: 4,
    moduleSize: 'small',
  });

  await handleFavoriteToggle(product, extraParams);
};

watch(
  () => props.productsIds,
  () => getSimilarProducts(props.productsIds).then((r) => (products.value = r)),
  { immediate: true }
);
</script>

<template>
  <CarouselSlides title="Похожие товары" :products="products">
    <template #default="{ product, position }">
      <ProductCard
        :product="product"
        :addToCartFn="addToCartFn"
        @favorite-toggle="(p) => handleFavoriteToggleWithParams(p, position)"
      />
    </template>
  </CarouselSlides>
</template>
